import { VisibilityClasses_Visibility_$ctor_Z207A3CFB, VisibilityClasses_ZIndex_$ctor_Z207A3CFB, VisibilityClasses_Opacity_$ctor_Z207A3CFB, PaintOrderClasses_PaintOrderClass_$ctor_Z207A3CFB } from "../Types/Visibility.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const PaintOrder = PaintOrderClasses_PaintOrderClass_$ctor_Z207A3CFB(new Property_CssProperty(215));

export const Opacity = VisibilityClasses_Opacity_$ctor_Z207A3CFB(new Property_CssProperty(188));

export const ZIndex = VisibilityClasses_ZIndex_$ctor_Z207A3CFB(new Property_CssProperty(314));

export const Visibility = VisibilityClasses_Visibility_$ctor_Z207A3CFB(new Property_CssProperty(296));

